import axiosInstance from "./axiosInstance";

export const getWastecategoryList = (params) => {
  return axiosInstance.get(`wastecategory?page=1&limit=100`, {
    params: params,
  });
};
